import { loadVariations } from '~/composables/shapes/utils'

export default defineNuxtPlugin(async () => {
  try {
    await loadVariations()
  } catch (error) {
    console.error('Error loading variations:', error)
  }
})
